var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const ATTENDANCE_API = 'api/attendance';
const ATTENDANCE_SOURCES = ["web_pos", "pos_v2", "unknown"];
const LOCATION_PERMISSION_STATUSES = [
    "granted",
    "denied",
    "unavailable",
    "not_requested",
    "error",
];
const stringValue = (value) => (typeof value === "string" && value.trim() ? value.trim() : undefined);
const numberValue = (value) => (typeof value === "number" && Number.isFinite(value) ? value : undefined);
const sourceValue = (value) => (ATTENDANCE_SOURCES.includes(value) ? value : undefined);
const permissionStatusValue = (value) => (LOCATION_PERMISSION_STATUSES.includes(value)
    ? value
    : undefined);
const dateValue = (value) => {
    if (value instanceof Date && !Number.isNaN(value.getTime()))
        return value;
    if (typeof value !== "string")
        return undefined;
    return Number.isNaN(new Date(value).getTime()) ? undefined : value;
};
const buildSafeAttendanceLocation = (location) => {
    if (!location)
        return undefined;
    const permissionStatus = permissionStatusValue(location.permissionStatus);
    if (!permissionStatus)
        return undefined;
    const safeLocation = {
        permissionStatus,
        capturedAt: dateValue(location.capturedAt),
        errorCode: stringValue(location.errorCode),
        errorMessage: stringValue(location.errorMessage),
    };
    if (permissionStatus === "granted") {
        safeLocation.latitude = numberValue(location.latitude);
        safeLocation.longitude = numberValue(location.longitude);
        safeLocation.accuracy = numberValue(location.accuracy);
        safeLocation.altitude = numberValue(location.altitude);
        safeLocation.altitudeAccuracy = numberValue(location.altitudeAccuracy);
        safeLocation.heading = numberValue(location.heading);
        safeLocation.speed = numberValue(location.speed);
    }
    const filteredEntries = Object.entries(safeLocation).filter(([, value]) => value !== undefined);
    return filteredEntries.length
        ? Object.fromEntries(filteredEntries)
        : undefined;
};
const buildSafeAttendanceMetadata = (metadata) => {
    if (!metadata)
        return undefined;
    const safeMetadata = {
        source: sourceValue(metadata.source),
        platform: stringValue(metadata.platform),
        appVersion: stringValue(metadata.appVersion),
        deviceId: stringValue(metadata.deviceId),
        language: stringValue(metadata.language),
        timezone: stringValue(metadata.timezone),
        screenWidth: numberValue(metadata.screenWidth),
        screenHeight: numberValue(metadata.screenHeight),
        location: buildSafeAttendanceLocation(metadata.location),
    };
    const filteredEntries = Object.entries(safeMetadata).filter(([, value]) => value !== undefined);
    return filteredEntries.length
        ? Object.fromEntries(filteredEntries)
        : undefined;
};
const buildAttendancePayload = (data) => {
    const metadata = buildSafeAttendanceMetadata(data.metadata);
    const payload = Object.assign({}, data);
    if (metadata) {
        payload.metadata = metadata;
    }
    else {
        delete payload.metadata;
    }
    return payload;
};
export const clockIn = function (data) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.post(`${ATTENDANCE_API}/clock-in`, buildAttendancePayload(data), config);
        }
        catch (error) {
            console.error('Error clock-in:', error);
            throw error;
        }
    });
};
export const clockOut = function (data) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.post(`${ATTENDANCE_API}/clock-out`, buildAttendancePayload(data), config);
        }
        catch (error) {
            console.error('Error clock-out:', error);
            throw error;
        }
    });
};
